import React from 'react'
import Navbar from '../defaultComponents/Navbar.jsx'
import Footer from '../defaultComponents/Footer.jsx'
import Iframe from 'react-iframe'
import {
  useNavigate
} from "react-router-dom";
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';

import styled from 'styled-components'
import Button from '@mui/material/Button';

const FormButtonContainer = styled.div`
  display: flex;

  width: 100%;

  padding: 1vw;

  gap: 1vw;

  background: white;
`

const FormButton = styled.button`
  background: none;

  color: #777777;
  font-weight: bold;
  border: 0;

  &.clicked {
    color: tomato;
  }
`

export default function EmployeeForms() {

  const LEAVE_URL = "https://form.jotform.com/231158623817054";
  const INTERNALPO_URL = "https://form.jotform.com/231930499118057";
  const DAILY_ENG_TIMESHEET = "https://form.jotform.com/231857679590877";
  const IT_SUPPORT_FORM = "https://form.jotform.com/231648879625068"

  const [formLink, setFormLink] = React.useState("")
  const [form, setForm] = React.useState("")
  const handleFormButtonClick = (buttonName) => {
    if (buttonName === 'leaveForm') {
      setFormLink(LEAVE_URL)
    }
    if (buttonName === 'internalPO') {
      setFormLink(INTERNALPO_URL)
    }

    if (buttonName === 'engTimesheet') {
      setFormLink(DAILY_ENG_TIMESHEET);
    }

    if (buttonName === 'itSupport') {
      setFormLink(IT_SUPPORT_FORM);
    }

    setForm(buttonName);
  }

  const navigate = useNavigate()

  return (
    <>
    <Navbar />
    <div className="all-page-background" style={{background: "#F8F8F8", width: "100%", height: "100%"}}>
      <div className="default-page-wrapper">
        <div className ="page-buttons-bar page-buttons-bar-curved">
        <Button sx ={{color: "white"}} onClick={()=>{navigate('/')}}> <ArrowBackOutlinedIcon sx={{marginRight: "5px", fontSize:"1rem"}}/> back</Button>
        </div>
        <div className ="page-buttons-bar">
          <div className='page-buttons-bar-subtitle'>IC360 Employee Forms</div>
        </div>

        <FormButtonContainer>
          <FormButton onClick={(e)=>{handleFormButtonClick(e.target.value)}} value={"leaveForm"} className={form === "leaveForm" ? "clicked" : ""}>Leave Form</FormButton>
          <FormButton onClick={(e)=>{handleFormButtonClick(e.target.value)}} value={"internalPO"} className={form === "internalPO" ? "clicked" : ""}>Internal PO</FormButton>
          <FormButton onClick={(e)=>{handleFormButtonClick(e.target.value)}} value={"engTimesheet"} className={form === "engTimesheet" ? "clicked" : ""}>Engineering Timesheet</FormButton>
          <FormButton onClick={(e)=>{handleFormButtonClick(e.target.value)}} value={"itSupport"} className={form === "itSupport" ? "clicked" : ""}>IT Support</FormButton>
        </FormButtonContainer>

        <Iframe url={formLink} height= "1500px" width="100%" frameBorder="0"/>

      </div>
    <Footer />
    </div>
    </>
  )
}
